import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import HudModal from "./HudModal";
import { DEPARTMENTS, formatErr, inputCls, labelCls } from "../lib/constants";

const empty = { name: "", email: "", role: "chef", hotel_code: "", department_code: "", password: "" };

export default function UserDialog({ open, target, hotels, onClose, onSaved }) {
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setForm(target ? { ...empty, ...target, hotel_code: target.hotel_code || "", department_code: target.department_code || "", password: "" } : empty);
  }, [open, target]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const body = { name: form.name, email: form.email, role: form.role, hotel_code: form.hotel_code || null, department_code: form.department_code || null, password: form.password || null };
      if (target) await api.put(`/users/${target.id}`, body);
      else await api.post("/users", body);
      toast.success(target ? "Kullanıcı güncellendi" : "Kullanıcı oluşturuldu");
      onSaved();
    } catch (err) {
      toast.error(formatErr(err));
    }
    setSaving(false);
  };

  return (
    <HudModal open={open} onClose={onClose} title={target ? "Kullanıcı Düzenle" : "Yeni Kullanıcı"} testid="user-dialog">
      <form onSubmit={save} className="space-y-3">
        <div><label className={labelCls}>Ad Soyad</label><input data-testid="uf-name" required value={form.name} onChange={set("name")} className={inputCls} /></div>
        <div><label className={labelCls}>E-posta</label><input data-testid="uf-email" type="email" required value={form.email} onChange={set("email")} className={inputCls} /></div>
        <div><label className={labelCls}>Rol</label>
          <select data-testid="uf-role" value={form.role} onChange={set("role")} className={inputCls}>
            <option value="chef">Departman Şefi</option>
            <option value="admin">İK Yöneticisi</option>
          </select>
        </div>
        {form.role === "chef" && (
          <div className="grid grid-cols-2 gap-3">
            <div><label className={labelCls}>Otel</label>
              <select data-testid="uf-hotel" required value={form.hotel_code} onChange={set("hotel_code")} className={inputCls}>
                <option value="">Seçin</option>
                {hotels.map((h) => <option key={h.code} value={h.code}>{h.name}</option>)}
              </select>
            </div>
            <div><label className={labelCls}>Departman</label>
              <select data-testid="uf-dept" required value={form.department_code} onChange={set("department_code")} className={inputCls}>
                <option value="">Seçin</option>
                {DEPARTMENTS.map((d) => <option key={d.code} value={d.code}>{d.name}</option>)}
              </select>
            </div>
          </div>
        )}
        <div><label className={labelCls}>{target ? "Yeni Şifre (boş bırakılırsa değişmez)" : "Şifre (en az 6 karakter)"}</label>
          <input data-testid="uf-password" type="password" required={!target} minLength={6} value={form.password} onChange={set("password")} className={inputCls} />
        </div>
        <button data-testid="uf-save" disabled={saving} className="w-full btn-cyan py-2.5 rounded-lg font-mono text-xs uppercase tracking-widest disabled:opacity-50">
          {saving ? "Kaydediliyor..." : "Kaydet"}
        </button>
      </form>
    </HudModal>
  );
}
